export default "__VITE_ASSET__DBSNcnIW__"